// About page: stats counter, image loading, smooth scroll
$(document).ready(function () {
	if (!$("body").hasClass("page-about") && !$(".about-page").length) {
		return;
	}

	// Stats counter animation via IntersectionObserver
	var statsObserver = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					var $el = $(entry.target).find(".stat-number");
					$el.each(function () {
						var $stat = $(this);
						if ($stat.hasClass("animated")) {
							return;
						}
						$stat.addClass("animated");
						var originalText = $stat.text();
						var countTo = parseInt(originalText.replace(/\D/g, ""));
						if (countTo && countTo > 0) {
							$({ countNum: 0 }).animate(
								{ countNum: countTo },
								{
									duration: 2000,
									easing: "swing",
									step: function () {
										$stat.text(Math.floor(this.countNum) + "+");
									},
									complete: function () {
										$stat.text(countTo + "+");
									},
								}
							);
						}
					});
					statsObserver.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.5 }
	);

	$(".about-hero-stats .stat-item").each(function () {
		statsObserver.observe(this);
	});

	// Image loaded state
	var imgSelector =
		".about-content-card img, .team-card img, .stories-card img";

	$(imgSelector).on("load", function () {
		$(this).addClass("loaded");
	});

	$(imgSelector).each(function () {
		if (this.complete) {
			$(this).addClass("loaded");
		}
	});

	$(window).on("load", function () {
		$(imgSelector).each(function () {
			$(this).addClass("loaded");
		});
	});

	// Smooth scroll for anchor links
	$('a[href^="#"]').on("click", function (e) {
		e.preventDefault();
		var target = $(this.getAttribute("href"));
		if (target.length) {
			$("html, body").animate({ scrollTop: target.offset().top - 80 }, 800);
		}
	});
});
